export const routesType = {
    lesson: "lesson",
    lessons: "lessons",
    contactUs: "contactUs"
}
